import Forward from 'assets/imgs/svg/forward.svg';
import React from 'react';
import {
  ActionBannerHeader,
  ActionButton,
  ActionButtonSection,
  ActionContainer,
  ActionList,
  StyledLink,
  SVGIcon,
} from './BlogAction.style';

const BlogAction = () => {
  return (
    <ActionContainer>
      <ActionButtonSection>
        <ActionBannerHeader>Where are you traveling to next?</ActionBannerHeader>

        <ActionButton type="primary" to={'/charterQuote'}>
          Search Private Jet Flights
          <SVGIcon>
            <img src={Forward} alt="button icon" />
          </SVGIcon>
        </ActionButton>
      </ActionButtonSection>

      <ActionList>
        <li>
          At <StyledLink to={'/'}>Airacer</StyledLink>, we simplify private jet charters—just pick
          your flight, get a quick{' '}
          <StyledLink to={'/charterQuote'}>private jet cost estimate</StyledLink>, and book in
          minutes.
        </li>
        <li>
          Have Questions? Our friendly <StyledLink to={'/contactUs'}>Flight Specialists</StyledLink>{' '}
          are always available to assist.
        </li>
        <li>
          Save big by checking out our <StyledLink to={'/emptyLeg'}>empty leg flights</StyledLink>{' '}
          for discounted private jet routes.
        </li>
      </ActionList>
    </ActionContainer>
  );
};

export default BlogAction;
